export default "6f0b7cf426afbceb.png"